<template>
    <div class="edit__box__input__extra__images__img" @click="deleteImage">
        <div :class="button">
            <i class="fa-solid fa-trash"></i>
        </div>
        <img :src="img" :class="image" alt="">
    </div>
</template>
<script>
export default {
    props:["img", "id"],
    data(){
        return{
            selected: false,
            button: "edit__box__input__extra__images__img__button",
            image: ""
        }
    },
    methods:{
        deleteImage(){
            if(this.selected){
                this.selected = false;
                this.button = "edit__box__input__extra__images__img__button";
                this.image = "";
                this.$emit('cancel_delete', this.$props.id)

            } else {
                this.selected = true;                
                this.button = "edit__box__input__extra__images__img__button__selected";
                this.image = "edit__box__input__extra__images__img__opacity";
                this.$emit('start_delete', this.$props.id);
            }
        }
    }
}
</script>